
import React from 'react';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-[200px]">
    <div className="relative">
      {/* Outer ring */}
      <div className="absolute inset-0 animate-ping rounded-full h-12 w-12 border-4 border-glowingTeal/20"></div>
      
      {/* Inner spinner */}
      <div className="animate-spin rounded-full h-12 w-12 border-t-3 border-b-3 border-glowingTeal"></div>
      
      {/* Center dot */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="h-2 w-2 rounded-full bg-glowingTeal"></div>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
